<template>
  <div class="course">
    <div class="course__thumb">
      <CourseThumb :course="course"/>

      <RoundIcon class="pos-bottom-center icon--relative">
        <BadgeSVG/>
      </RoundIcon>
    </div>
  </div>
</template>

<script>
import CourseThumb from '@/components/course/CourseThumb'
import RoundIcon from '@/components/icon/RoundIcon'
import BadgeSVG from '@/components/svg/BadgeSVG'

export default {
  components: {
    CourseThumb,
    RoundIcon,
    BadgeSVG,
  },

  props: {
    course: { type: Object, required: true }
  }
}
</script>

<style scoped lang="scss">
  .course {
    &__thumb {
      position: relative;
      width: 80px;
      flex: 0 0 auto;
    }
  }
</style>